import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ILicenseTypes } from '../interfaces/license-type';
import { ILicenseTypesFilter } from '../interfaces/license-type-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class LicenseTypesService extends EditService<ILicenseTypes, ILicenseTypesFilter> {
  url = '/api/licensetypes';
  entityTitle = 'LicenseTypes';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }
}
